import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function RootCause() {
  const factors = ['comer apurada,', 'estrés alto,', 'gaseosas/azúcar/ultraprocesados de “rescate”,', 'porciones grandes cuando llegás con hambre,', 'y poco movimiento…'];
  return <section className="py-24 px-4 bg-cream-dark relative overflow-hidden" data-id="element-149">
      {/* Background texture/shape */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-terracotta/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-150" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-151">
        <FadeIn data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-serif text-brown mb-8 text-center" data-id="element-153">
            Por qué esto te pasa{' '}
            <span className="block text-2xl md:text-3xl text-brown-light mt-2 font-sans font-normal" data-id="element-154">
              (y por qué no es tu culpa)
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-155">
          <p className="text-xl text-brown mb-8 text-center font-medium" data-id="element-156">
            Porque tu panza no vive separada de tu vida.
          </p>
        </FadeIn>

        <div className="bg-white/60 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-white shadow-sm mb-12" data-id="element-157">
          <FadeIn delay={0.3} data-id="element-158">
            <p className="text-lg text-brown-light mb-6" data-id="element-159">Si combinás:</p>
            <ul className="space-y-3 mb-8 pl-4 border-l-2 border-sage/30" data-id="element-160">
              {factors.map((factor, i) => <li key={i} className="text-lg md:text-xl text-brown font-medium" data-id="element-161">
                  {factor}
                </li>)}
            </ul>
            <p className="text-lg text-brown-light" data-id="element-162">
              la hinchazón aparece aunque estés “intentando”.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} className="text-center" data-id="element-163">
          <p className="text-lg text-brown-light mb-4" data-id="element-164">
            Y encima te queda el pensamiento más feo:
          </p>
          <blockquote className="text-2xl md:text-3xl font-serif text-terracotta italic" data-id="element-165">
            “¿Qué más tengo que hacer para sentirme normal?”
          </blockquote>
        </FadeIn>
      </div>
    </section>;
}